export const PRECISION = {
  TUBE_RADIUS_DECIMALS: 5,
  ANGLE_IRON_LENGTH_DECIMALS: 5,
  SPATIAL_MEASUREMENT_DECIMALS: 5,
  DISPLAY_ANGLE_DECIMALS: 2,
  DEFAULT_UNIT_DISPLAY_DECIMALS: 3,
  MIN_THICKNESS_VALUE: 0.01,
  MIN_THICKNESS_FALLBACK: 0.001,
  UNIT_CONVERSION_MULTIPLIER: 10000,
} as const;
